import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import { SuccessModal } from '@phx-husky/common-components';
import { useProfile } from '@phx-husky/use-profile';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import React, { useState } from 'react';

import { Form } from '../form';
import { ChangePasswordProps } from '../models';
import * as styles from './security-section.module.scss';

export const ChangePassword = ({
  fields,
  editButtonDisabled,
  onFormCloseCallback,
}: ChangePasswordProps) => {
  const [formVisible, setFormVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const { changePassword } = useProfile();
  const { translate } = useTranslations();

  const onClose: ChangePasswordProps['onFormCloseCallback'] = (params) => {
    setFormVisible(false);
    onFormCloseCallback(params);
  };

  return (
    <div className={classNames(styles.section, 'auth-profile-section')}>
      <Typography
        variant="headline"
        className={styles.title}
        content={translate('securityPasswordSectionTitle')}
      />
      {formVisible ? (
        <Form
          fields={fields}
          onSubmit={changePassword}
          onSuccess={() => setSuccessModalVisible(true)}
          cancelButtonLabel={translate('securityPasswordEditCancelButton')}
          submitButtonLabel={translate('securityPasswordEditSubmitButton')}
          onClose={onClose}
          buttonsOrientation="left"
        />
      ) : (
        <Button
          variant="primary"
          className={classNames('auth-profile-section__button-account')}
          type="button"
          onClick={() => setFormVisible(true)}
          disabled={editButtonDisabled}
        >
          {translate('profileSecurityButton')}
        </Button>
      )}
      <SuccessModal
        isShowing={successModalVisible}
        title={translate('securityPasswordEditSuccessModalTitle')}
        body={translate('securityPasswordChangeSuccessModalMessage')}
        closeButtonLabel={translate('securityPasswordEditSuccessModalButton')}
        onClose={() => setSuccessModalVisible(false)}
      />
    </div>
  );
};
